module.exports = __webpack_public_path__ + "img/jypx-2.b2766c7d.webp";